import { useEffect } from 'react'
import { useSignal } from '@preact/signals-react'
import { getSubmit } from '@ui-seeker/utils'
import { useToast } from '@hooks'
import { BACKEND_APIS } from '@constants'


export default function useRatingHistorical(idReport) {
	const { showToast } = useToast()
	const reportName = useSignal('')
	const data = useSignal([])
	const isLoading = useSignal(true)

	useEffect(() => {
		getSubmit(BACKEND_APIS.REPORTS_EXECUTIONS_RATING, { idReport })
			.then(({ reportName: name, result }) => {
				reportName.value = name
				data.value = result
			})
			.catch(() => showToast.error())
			.finally(() => isLoading.value = false)
	}, [])

	return {
		reportName: reportName.value,
		data: data.value,
		isLoading: isLoading.value,
	}
}